import { closestCenter, DndContext, KeyboardSensor, MouseSensor, TouchSensor, useSensor, useSensors } from '@dnd-kit/core';
import { restrictToVerticalAxis } from '@dnd-kit/modifiers';
import { arrayMove, SortableContext, useSortable, verticalListSortingStrategy } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { IconArrowDown, IconArrowDownLeft, IconArrowDownRight, IconArrowLeft, IconArrowRight, IconArrowUp, IconArrowUpLeft, IconArrowUpRight, IconGripVertical, IconTrashFilled } from '@tabler/icons-react';
import _debounce from 'lodash/debounce';
import React, { useEffect, useRef, useState } from 'react';
import { toast } from 'sonner';
import { uploadImage } from '../../../api/api.global';
import { postApi } from '../../../api/call.api';
import { urlApi } from '../../../api/url.api';
import ConfirmationModal from '../../../components/ConfirmationModal/ConfirmationModal';
import { ensureHttpPrefix } from '../../../utils/url.utils';

const CreatePage = ({ state, pageId, callback }) => {

    const [pageData, setPageData] = useState(state);

    useEffect(() => {
        setPageData(state);
        setSelectedSocialLinks(state.socialLinks);
        setSelectedBgMode(state?.backgroundOption?.backgroundType);
        setSelectedHeaderMode(state.headerOption?.backgroundType);
    }, [state])

    const imageUploadInputRef = useRef(null);
    const backgroundImageInputRef = useRef(null)
    const headerImageInputRef = useRef(null);
    const mouseSensor = useSensor(MouseSensor)
    const touchSensor = useSensor(TouchSensor)
    const keyboardSensor = useSensor(KeyboardSensor)

    const sensors = useSensors(mouseSensor, touchSensor, keyboardSensor)
    const presets = [
        {
            id: 1,
            colors: ['#fff', '#ffffff90']
        }, {
            id: 2,
            colors: ['#C2E9FB', '#88BFFF']
        }, {
            id: 3,
            colors: ['#56CCF2', '#74EBD5']
        }, {
            id: 4,
            colors: ['#FFE06F', '#F85C8B']
        }, {
            id: 5,
            colors: ['#FF78A1', '#CB1D52']
        }, {
            id: 6,
            colors: ['#4B6CB7', '#182848']
        }, {
            id: 7,
            colors: ['#147A8E', '#042A44']
        }, {
            id: 8,
            colors: ['#525457', '#232526']
        }
    ];

    const socialLinks = [
        {
            sortId: 1,
            name: 'instagram',
            icon: "https://advy.downlink.in/website-assets/v2/instagram.svg",
            regex: /^(https?:\/\/)?(www\.)?(instagram\.com|instagr\.am)/,
            placeholder: 'instagram.com/username'
        }, {
            sortId: 2,
            name: 'facebook',
            icon: "https://advy.downlink.in/website-assets/v2/facebook.svg",
            regex: /^(https?:\/\/)?(www\.)?(facebook\.com|fb\.com)/,
            placeholder: 'facebook.com/pageurl'
        }, {
            sortId: 3,
            name: 'youtube',
            icon: "https://advy.downlink.in/website-assets/v2/youtube.svg",
            regex: /^(https?:\/\/)?(www\.)?(youtube\.com|youtu\.be)/,
            placeholder: 'youtube.com/channel/channelurl'

        }, {
            sortId: 4,
            name: 'whatsapp',
            icon: "https://advy.downlink.in/website-assets/v2/whatsapp.svg",
            regex: /^(https?:\/\/)?(wa\.me|www\.whatsapp\.com)/,
            placeholder: 'wa.me/1234567890'
        }, {
            sortId: 5,
            name: 'telegram',
            icon: "https://advy.downlink.in/website-assets/v2/telegram.svg",
            regex: /^(https?:\/\/)?(www\.)?(telegram\.me|t\.me)/,
            placeholder: 't.me/channelurl'
        }, {
            sortId: 6,
            name: 'tiktok',
            icon: "https://advy.downlink.in/website-assets/v2/tiktok.svg",
            regex: /^(https?:\/\/)?(www\.)?tiktok\.com/,
            placeholder: 'tiktok.com/@username'
        }, {
            sortId: 7,
            name: 'snapchat',
            icon: "https://advy.downlink.in/website-assets/v2/snapchat.svg",
            regex: /^(https?:\/\/)?(www\.)?snapchat\.com/,
            placeholder: 'snapchat.com/username'
        }, {
            sortId: 8,
            name: 'spotify',
            icon: "https://advy.downlink.in/website-assets/v2/spotify.svg",
            regex: /^(https?:\/\/)?(open\.)?spotify\.com/,
            placeholder: 'open.spotify.com/'
        }, {
            sortId: 9,
            name: 'email',
            icon: "https://advy.downlink.in/website-assets/v2/email.svg",
            regex: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.(com|org|net|edu|gov|io|co|in|app|co.in)$/,
            placeholder: 'email@example.com'
        }, {
            sortId: 10,
            name: 'appleMusic',
            icon: "https://advy.downlink.in/website-assets/v2/apple-music.svg",
            regex: /^(https?:\/\/)?(www\.)?music\.apple\.com/,
            placeholder: 'music.apple.com/'
        }, {
            sortId: 11,
            name: 'discord',
            icon: "https://advy.downlink.in/website-assets/v2/discord.svg",
            regex: /^(https?:\/\/)?(www\.)?(discord\.gg|discord\.com)/,
            placeholder: 'discord.com/channelurl'
        }, {
            sortId: 12,
            name: 'linkedin',
            icon: "https://advy.downlink.in/website-assets/v2/linkedin.svg",
            regex: /^(https?:\/\/)?(www\.)?linkedin\.com/,
            placeholder: 'linkedin.com/in/username'
        }, {
            sortId: 13,
            name: 'mastodon',
            icon: "https://advy.downlink.in/website-assets/v2/mastodon.svg",
            regex: /^(https?:\/\/)?[a-zA-Z0-9.-]+\/@([a-zA-Z0-9._-]+)\/?$/,
            placeholder: 'mastodon.social/@username'
        }, {
            sortId: 14,
            name: 'pinterest',
            icon: "https://advy.downlink.in/website-assets/v2/pinterest.svg",
            regex: /^(https?:\/\/)?(www\.)?(pinterest\.com|pin\.it)/,
            placeholder: 'pinterest.com/username'
        }, {
            sortId: 15,
            name: 'reddit',
            icon: "https://advy.downlink.in/website-assets/v2/reddit.svg",
            regex: /^(https?:\/\/)?(www\.)?reddit\.com/,
            placeholder: 'reddit.com/u/username'
        }, {
            sortId: 16,
            name: 'soundcloud',
            icon: "https://advy.downlink.in/website-assets/v2/soundcloud.svg",
            regex: /^(https?:\/\/)?(www\.)?soundcloud\.com/,
            placeholder: 'soundcloud.com/username'
        }, {
            sortId: 17,
            name: 'threads',
            icon: "https://advy.downlink.in/website-assets/v2/threads.svg",
            regex: /^(https?:\/\/)?(www\.)?threads\.net/,
            placeholder: 'threads.net/@username'
        }, {
            sortId: 18,
            name: 'twitch',
            icon: "https://advy.downlink.in/website-assets/v2/twitch.svg",
            regex: /^(https?:\/\/)?(www\.)?twitch\.tv/,
            placeholder: 'twitch.tv/username'
        }, {
            sortId: 19,
            name: 'x',
            icon: "https://advy.downlink.in/website-assets/v2/x.svg",
            regex: /^(https?:\/\/)?(www\.)?(x\.com|twitter\.com)/,
            placeholder: 'x.com/handle'
        }
    ];

    const fonts = [
        {
            id: 1,
            name: "Montserrat"
        }, {
            id: 2,
            name: 'Anton',
        }, {
            id: 3,
            name: 'Josefin Sans'
        }, {
            id: 4,
            name: 'Open Sans'
        }, {
            id: 5,
            name: 'Oswald'
        }, {
            id: 6,
            name: 'Titillium Web'
        }, {
            id: 7,
            name: 'Roboto'
        }, {
            id: 8,
            name: 'Raleway'
        }, {
            id: 9,
            name: 'Arvo'
        }, {
            id: 10,
            name: 'Cormorant Garamond'
        }, {
            id: 11,
            name: 'Libre Baskerville'
        }, {
            id: 12,
            name: 'Slabo'
        }, {
            id: 13,
            name: 'Amatic SC'
        }, {
            id: 14,
            name: 'Itim'
        }, {
            id: 15,
            name: 'Architects Daughter'
        }, {
            id: 16,
            name: 'Permanent Marker'
        }
    ];

    const [selectedBgMode, setSelectedBgMode] = useState(state?.backgroundOption?.backgroundType || 1);
    const [selectedHeaderMode, setSelectedHeaderMode] = useState(state?.headerOption.backgroundType || 1);
    const [selectedSocialLinks, setSelectedSocialLinks] = useState(state?.socialLinks || []);

    async function update(postDetails) {
        let postData = {
            linkId: pageId,
            postData: postDetails
        }
        let resp = await postApi(postData, urlApi.editPageData);
        if (resp?.responseCode === 200) {
            if (callback) {
                callback();
            }
        }
        if (resp.responseCode === 500) {
            toast.error(resp.message);
        }
    }

    const handleImageChange = async (e) => {
        const file = e.target.files[0];
        const maxSizeInBytes = 1024 * 1024 * 5;
        if (file && file.size > maxSizeInBytes) {
            toast.error('File size exceeds the limit of 5MB.');
            e.target.value = null;
        } else {
            let imageResp = await uploadImage(file, 'advy-pages');
            if (imageResp) {
                let postData = [{
                    key: 'image',
                    value: imageResp
                }]
                update(postData);
                e.target.value = null;
            }
        }
    }

    const handleTitleChange = (e) => {
        let postData = [{
            key: 'title',
            value: e.target.value
        }]
        update(postData);
    };

    const handleDescriptionChange = (e) => {
        let postData = [{
            key: 'description',
            value: e.target.value
        }]
        update(postData);
    }

    const onProfileImgRemove = () => {
        let postData = [{
            key: 'image',
            value: ''
        }]
        update(postData);
    }

    const handlePresetClick = (item) => {
        let postData = [{
            key: 'backgroundOption.gradient',
            value: item?.colors
        }, {
            key: 'backgroundOption.color',
            value: ''
        }, {
            key: 'backgroundOption.image',
            value: ''
        }, {
            key: 'backgroundOption.preset',
            value: item?.id
        }, {
            key: 'backgroundOption.backgroundType',
            value: 2
        }, {
            key: 'headerOption.color',
            value: ''
        }, {
            key: 'headerOption.image',
            value: ''
        }, {
            key: 'headerOption.backgroundType',
            value: 2
        }, {
            key: 'headerOption.gradient',
            value: item?.colors
        }];
        update(postData);
    }

    const handleBackgroundGradientChange = (color1, color2) => {
        let postData = [{
            key: 'backgroundOption.gradient',
            value: [color1, color2]
        }, {
            key: 'backgroundOption.color',
            value: ''
        }, {
            key: 'backgroundOption.image',
            value: ''
        }, {
            key: 'backgroundOption.backgroundType',
            value: 2
        }]
        update(postData);
    }

    const onBackgroundColorChange = (e) => {
        let postData = [{
            key: 'backgroundOption.gradient',
            value: []
        }, {
            key: 'backgroundOption.image',
            value: ''
        }, {
            key: 'backgroundOption.color',
            value: e.target.value
        }, {
            key: 'backgroundOption.backgroundType',
            value: 1
        }]
        update(postData);
    }

    const onBackgroundGradientAngleChange = (angle) => {
        let postData = [{
            key: 'backgroundOption.gradientAngle',
            value: angle
        }];
        update(postData);
    }

    const handleHeaderGradientChange = (color1, color2) => {
        let postData = [{
            key: 'headerOption.gradient',
            value: [color1, color2]
        }, {
            key: 'headerOption.color',
            value: ''
        }, {
            key: 'headerOption.image',
            value: ''
        }, {
            key: 'headerOption.backgroundType',
            value: 2
        }];
        update(postData);
    }

    const onHeaderColorChange = (e) => {
        let postData = [{
            key: 'headerOption.color',
            value: e.target.value
        }, {
            key: 'headerOption.gradient',
            value: []
        }, {
            key: 'headerOption.image',
            value: ''
        }, {
            key: 'headerOption.backgroundType',
            value: 1
        }];
        update(postData);
    }

    const onHeaderGradientAngleChange = (angle) => {
        let postData = [{
            key: 'headerOption.gradientAngle',
            value: angle
        }];
        update(postData)
    }

    const onTextColorChange = (e) => {
        let postData = [{
            key: 'textOption.titleColor',
            value: e.target.value
        }];
        update(postData);
    }

    const onDescriptionColorChange = (e) => {
        let postData = [{
            key: 'textOption.descriptionColor',
            value: e.target.value
        }];
        update(postData);
    }

    const onLayoutChange = (layout) => {
        let postData = [{
            key: 'layout',
            value: layout
        }]
        update(postData);
    }

    const onBackgroundImageChange = async (e) => {
        const file = e.target.files[0];
        const maxSizeInBytes = 1024 * 1024 * 5;
        if (file && file.size > maxSizeInBytes) {
            toast.error('File size exceeds the limit of 5MB.');
            e.target.value = null;
        } else {
            let imageResp = await uploadImage(file, 'advy-pages');
            let postData = [{
                key: 'backgroundOption.image',
                value: imageResp
            }, {
                key: 'backgroundOption.gradient',
                value: []
            }, {
                key: 'backgroundOption.color',
                value: ''
            }, {
                key: 'backgroundOption.backgroundType',
                value: 3
            }];
            update(postData);
            e.target.value = null;
        }
    }

    const onBackgroundImageRemove = () => {
        let postData = [{
            key: 'backgroundOption.image',
            value: ''
        }, {
            key: 'backgroundOption.color',
            value: '#ffffff'
        }];
        update(postData);
    }

    const onHeaderImageChange = async (e) => {
        const file = e.target.files[0];
        const maxSizeInBytes = 1024 * 1024 * 5;
        if (file && file.size > maxSizeInBytes) {
            toast.error('File size exceeds the limit of 5MB.');
            e.target.value = null;
        } else {
            let imageResp = await uploadImage(file, 'advy-pages');
            let postData = [{
                key: 'headerOption.image',
                value: imageResp
            }, {
                key: 'headerOption.gradient',
                value: []
            }, {
                key: 'headerOption.color',
                value: ''
            }, {
                key: 'headerOption.backgroundType',
                value: 3
            }];
            update(postData);
            e.target.value = null;
        }
    }

    const onHeaderImageRemove = () => {
        let postData = [{
            key: 'headerOption.image',
            value: ''
        }];
        update(postData);
    }

    const onSocialIconSelect = (item) => {
        let local = [...selectedSocialLinks];
        if (local.some((x) => x.channelName == item?.name)) {
            return;
        }

        let sortIdArray = local.map((x) => x?.sortId)
        let maxSortId = Math.max(...sortIdArray, 1);
        let linkData = { channelName: item?.name, channelLink: null, sortId: maxSortId + 1, icon: item?.icon };
        local.push(linkData);
        setSelectedSocialLinks(local);
    };

    const onSocialIconPositionChange = (e) => {
        let postData = [{
            key: 'socialLinksOption.placement',
            value: e.target.value
        }];
        update(postData);
    }

    const onSocialLinkTypeComplete = (e, item) => {
        if (e.target.value) {
            let local = [...selectedSocialLinks];
            let linkData = local.find((x) => x.sortId == item?.sortId);
            let socialLinkData = socialLinks.find((x) => x.name == item?.channelName);
            if (!socialLinkData?.regex.test(e.target.value)) {
                toast.error(socialLinkData?.name + " Link is not valid");
                return;
            }
            linkData.channelLink = linkData?.channelName == 'email' ? e.target.value : ensureHttpPrefix(e.target.value);
            setSelectedSocialLinks(local);
            let filteredSocialLinks = local.filter((x) => x.channelLink);
            let postData = [{
                key: 'socialLinks',
                value: filteredSocialLinks
            }];
            update(postData);
        }
    };

    // drag and sort starts

    function handleDragEnd(event) {
        const { active, over } = event;
        if (over && active?.id !== over?.id) {
            let local = [...selectedSocialLinks];
            const activeIndex = local.findIndex(item => item.sortId === active.id);
            const overIndex = local.findIndex(item => item.sortId === over.id);
            let newArr = arrayMove(local, activeIndex, overIndex);
            let postData = [{
                key: 'socialLinks',
                value: newArr
            }]
            setSelectedSocialLinks(newArr);
            update(postData);
        }
    }

    const handleDeleteDraggableItem = (itemId) => {
        let localPageData = [...selectedSocialLinks]
        const filteredLinks = localPageData?.filter((link) => link.sortId !== itemId);
        localPageData = filteredLinks;
        setSelectedSocialLinks(localPageData);
        let postData = [{
            key: 'socialLinks',
            value: localPageData
        }];
        update(postData);
    }
    // drag and sort end

    const onBlockStyleSelectionChange = (borderRadius, background) => {
        let postData = [{
            key: 'blocksOption.borderRadius',
            value: borderRadius
        }, {
            key: 'blocksOption.background',
            value: background
        }];
        update(postData);
    };

    const onBlockShadowSelect = (shadowSize) => {
        let postData = [{
            key: 'blocksOption.shadowSize',
            value: shadowSize
        }];
        update(postData);
    }

    const onBlockBorderSelect = (borderSize) => {
        let postData = [{
            key: 'blocksOption.border',
            value: borderSize
        }];
        update(postData);
    }

    const onBlockTitleColorChange = (e) => {
        let postData = [{
            key: 'blocksOption.titleColor',
            value: e.target.value
        }];
        update(postData);
    };

    const onBlockBgColorChange = (e) => {
        let postData = [{
            key: 'blocksOption.background',
            value: e.target.value
        }];
        update(postData);
    }

    const onBlockBorderColorChange = (e) => {
        let postData = [{
            key: 'blocksOption.borderColor',
            value: e.target.value
        }];
        update(postData);
    };

    const onBlockDescriptionColorChange = (e) => {
        let postData = [{
            key: 'blocksOption.descriptionColor',
            value: e.target.value
        }];
        update(postData);
    };

    const onFontSelect = (font) => {
        let postData = [{
            key: 'textOption.font',
            value: font.name
        }];
        update(postData);
    }

    return (
        <>
            <div className="col-span-3 md:col-span-2">

                {/* profile */}
                <div className="border border-1 border-[#ECECF2] p-2 rounded-xl mb-3">
                    <p className='text-sm font-bold'>Profile</p>
                    <div className="flex gap-3 items-center">
                        <input type="file" accept="image/*" name="" id="" className="hidden" onChange={handleImageChange} ref={imageUploadInputRef} />
                        <img src={pageData?.image ? (pageData?.image) : (process.env.PUBLIC_URL + "/images/image-upload.png")} className='h-20 aspect-square rounded-lg object-cover' alt="" />
                        <button onClick={() => imageUploadInputRef.current.click()} className='rounded-full px-3 py-1 font-semibold text-sm text-primary border-2 border-primary h-max'>Upload Image</button>
                        <ConfirmationModal buttonComponent={<button className='rounded-full px-3 py-1 font-semibold text-sm text-[var(--secondary)] border-2 border-[var(--secondary)] h-max'>Remove</button>} onConfirm={() => onProfileImgRemove()} confirmationText={"Are You Sure Want To Remove The Image?"} />
                    </div>
                    <p className='text-xs text-[#B4B7D8]'>*Image Should Be In 1:1 Ratio and Within 5Mb</p>
                    <div className="from-group mt-3 mb-2">
                        <label htmlFor="" className='font-bold text-sm'>Title<span className='font-normal text-xs text-gray-500'> (Optional , Max 32 Characters)</span></label>
                        <input type="text" className="form-control" placeholder="Enter Title" defaultValue={pageData?.title} onChange={_debounce((e) => handleTitleChange(e), 300)} maxLength={32} />
                    </div>
                    <div className="from-group">
                        <label htmlFor="" className='font-bold text-sm'>Description<span className='font-normal text-xs text-gray-500'> (Optional , Max 120 Characters)</span></label>
                        <input type="text" className="form-control" placeholder="Enter Description" defaultValue={pageData?.description} onChange={_debounce((e) => handleDescriptionChange(e), 400)} maxLength={120} />
                    </div>
                </div>

                {/* theme */}
                <div className="border border-1 border-[#ECECF2] p-2 rounded-xl mb-3">
                    <p className='text-sm font-bold'>Themes</p>

                    <div className='flex gap-3 mb-4 flex-wrap'>
                        {
                            presets.map((item) => {
                                return (
                                    <div key={item?.id} className={`p-1  rounded-full ${pageData?.backgroundOption?.preset == item?.id && 'outline outline-2 outline-primary'}`}>
                                        <div key={item?.id} className={`h-10 shadow aspect-square cursor-pointer rounded-full`} style={{ background: `linear-gradient( to bottom, ${item.colors[0]} , ${item.colors[1]})` }} onClick={() => handlePresetClick(item)}>  </div>
                                    </div>
                                )
                            })
                        }
                    </div>

                    <p className='text-sm font-bold'>Layout</p>
                    <div className="flex gap-2 mb-4">
                        <button className={`${pageData?.layout == 1 && 'border-2 border-primary'} rounded-xl overflow-hidden`} onClick={() => onLayoutChange(1)}> <img src={process.env.PUBLIC_URL + "/images/page-layouts/template1.png"} alt="" /></button>
                        <button className={`${pageData?.layout == 2 && 'border-2 border-primary'} rounded-xl overflow-hidden`} onClick={() => onLayoutChange(2)}> <img src={process.env.PUBLIC_URL + "/images/page-layouts/template2.png"} alt="" /></button>
                        <button className={`${pageData?.layout == 3 && 'border-2 border-primary'} rounded-xl overflow-hidden`} onClick={() => onLayoutChange(3)}> <img src={process.env.PUBLIC_URL + "/images/page-layouts/template3.png"} alt="" /></button>
                        <button className={`${pageData?.layout == 4 && 'border-2 border-primary'} rounded-xl overflow-hidden`} onClick={() => onLayoutChange(4)}> <img src={process.env.PUBLIC_URL + "/images/page-layouts/template4.png"} alt="" /></button>
                        <button className={`${pageData?.layout == 5 && 'border-2 border-primary'} rounded-xl overflow-hidden`} onClick={() => onLayoutChange(5)}> <img src={process.env.PUBLIC_URL + "/images/page-layouts/template5.png"} alt="" /></button>
                    </div>

                    {
                        (pageData?.layout == 2 || pageData?.layout == 3 || pageData?.layout == 4) &&
                        <div className='mb-5'>
                            {/* header mode start */}
                            <div className="flex flex-wrap items-center justify-between mb-3">
                                <p className='text-sm font-bold mb-0'>Header</p>
                                <div className="flex gap-3 bg-[#F4F6FA] px-4 py-1.5 rounded-full">
                                    <button className={`px-4 text-sm font-semibold py-1 rounded-full ${selectedHeaderMode == 1 ? 'bg-white text-[#273144]' : 'bg-transparent text-[#526281]'}`} onClick={() => setSelectedHeaderMode(1)}>Color</button>
                                    <button className={`px-4 text-sm font-semibold py-1 rounded-full ${selectedHeaderMode == 2 ? 'bg-white text-[#273144]' : 'bg-transparent text-[#526281]'}`} onClick={() => setSelectedHeaderMode(2)}>Gradient</button>
                                    <button className={`px-4 text-sm font-semibold py-1 rounded-full ${selectedHeaderMode == 3 ? 'bg-white text-[#273144]' : 'bg-transparent text-[#526281]'}`} onClick={() => setSelectedHeaderMode(3)}>Image</button>
                                </div>
                            </div>

                            {
                                selectedHeaderMode === 1 && (
                                    <div className='flex'>
                                        <input type="color" className='h-8 w-8 rounded-s-lg focus-within:outline-none border-none focus:outline-none focus:border-none' name="" id="" onChange={_debounce((e) => onHeaderColorChange(e), 300)} defaultValue={pageData?.headerOption?.color} key={pageData?.headerOption?.color} />
                                        <input type="text" className='text-black rounded-e-lg bg-[#E8EBF2] p-1 text-sm focus:outline-none' name="" id="" onBlur={(e) => onHeaderColorChange(e)} defaultValue={pageData?.headerOption?.color} key={"input-head-" + pageData?.headerOption?.color} />
                                    </div>
                                )
                            }

                            {
                                selectedHeaderMode === 2 && (
                                    <div className="flex flex-wrap gap-5 items-center">
                                        <div>
                                            <p className='mb-1'>&nbsp;</p>
                                            <div className='flex items-center h-[40px]'>
                                                <input type="color" name="" id="bg-gradient-1" className='h-10 aspect-square rounded-s-md cursor-pointer' onChange={_debounce((e) => handleHeaderGradientChange(e?.target?.value, document.getElementById('bg-gradient-2').value?.trim()), 300)} defaultValue={pageData?.headerOption?.gradient?.length ? pageData?.headerOption?.gradient[0] : "red"}
                                                    key={pageData?.headerOption?.gradient?.length ? pageData?.headerOption?.gradient[0] : "header-gradient-1"}
                                                />

                                                <div className='w-32 h-full' style={{ background: `linear-gradient( ${pageData?.headerOption?.gradientAngle ? pageData?.headerOption?.gradientAngle : 'to bottom'}, ${pageData?.headerOption?.gradient?.length ? pageData?.headerOption?.gradient[0] : 'red'} , ${pageData?.headerOption?.gradient ? pageData?.headerOption?.gradient[1] : 'blue'})` }}></div>

                                                <input type="color" name="" id="bg-gradient-2" className='h-10 aspect-square rounded-e-md cursor-pointer' onChange={_debounce((e) => handleHeaderGradientChange(document.getElementById('bg-gradient-1').value?.trim(), e?.target?.value), 300)} defaultValue={pageData?.headerOption?.gradient?.length ? pageData?.headerOption?.gradient[1] : "blue"}
                                                    key={pageData?.headerOption?.gradient?.length ? pageData?.headerOption?.gradient[1] : "header-gradient-2"}
                                                />
                                            </div>
                                        </div>
                                        <div>
                                            <p className='text-sm font-bold mb-1'>Direction</p>
                                            <div className="flex flex-wrap gap-2 items-center">
                                                <button className={`border-2 ${pageData?.headerOption?.gradientAngle == "to bottom" ? 'border-primary' : 'border-[#DBE0EB]'} rounded-full p-2`} onClick={() => onHeaderGradientAngleChange('to bottom')}> <IconArrowDown /> </button>

                                                <button className={`border-2 ${pageData?.headerOption?.gradientAngle == "to top" ? 'border-primary' : 'border-[#DBE0EB]'} rounded-full p-2`} onClick={() => onHeaderGradientAngleChange('to top')}> <IconArrowUp /> </button>

                                                <button className={`border-2 ${pageData?.headerOption?.gradientAngle == "to left" ? 'border-primary' : 'border-[#DBE0EB]'} rounded-full p-2`} onClick={() => onHeaderGradientAngleChange('to left')}> <IconArrowLeft /> </button>

                                                <button className={`border-2 ${pageData?.headerOption?.gradientAngle == "to right" ? 'border-primary' : 'border-[#DBE0EB]'} rounded-full p-2`} onClick={() => onHeaderGradientAngleChange('to right')}> <IconArrowRight /> </button>

                                                <button className={`border-2 ${pageData?.headerOption?.gradientAngle == "to right top" ? 'border-primary' : 'border-[#DBE0EB]'} rounded-full p-2`} onClick={() => onHeaderGradientAngleChange('to right top')}> <IconArrowUpRight /> </button>

                                                <button className={`border-2 ${pageData?.headerOption?.gradientAngle == "to left top" ? 'border-primary' : 'border-[#DBE0EB]'} rounded-full p-2`} onClick={() => onHeaderGradientAngleChange('to left top')}> <IconArrowUpLeft /> </button>

                                                <button className={`border-2 ${pageData?.headerOption?.gradientAngle == "to left bottom" ? 'border-primary' : 'border-[#DBE0EB]'} rounded-full p-2`} onClick={() => onHeaderGradientAngleChange('to left bottom')}> <IconArrowDownLeft /> </button>

                                                <button className={`border-2 ${pageData?.headerOption?.gradientAngle == "to right bottom" ? 'border-primary' : 'border-[#DBE0EB]'} rounded-full p-2`} onClick={() => onHeaderGradientAngleChange('to right bottom')}> <IconArrowDownRight /> </button>
                                            </div>
                                        </div>
                                    </div>
                                )
                            }

                            {
                                selectedHeaderMode === 3 && (
                                    <div className="flex flex-wrap gap-3 items-center">
                                        <input type="file" accept="image/*" name="" id="" className="hidden" onChange={onHeaderImageChange} ref={headerImageInputRef} />
                                        <div>
                                            <img src={pageData?.headerOption?.image ? (pageData?.headerOption?.image) : (process.env.PUBLIC_URL + "/images/image-upload.png")} className='cursor-pointer h-20 aspect-square rounded-lg object-cover' alt="" />
                                            <p className="text-xs text-gray-400">*Maximum size: 5MB & preferred ratio is 16:9 </p>
                                        </div>
                                        <button onClick={() => headerImageInputRef.current.click()} className='rounded-full px-3 py-1 font-semibold text-sm text-primary border-2 border-primary h-max'>Upload Image</button>

                                        <ConfirmationModal buttonComponent={<button className='rounded-full px-3 py-1 font-semibold text-sm text-[var(--secondary)] border-2 border-[var(--secondary)] h-max'>Remove</button>} confirmationText={"Are you sure want to remove header background image?"} onConfirm={() => onHeaderImageRemove()} />
                                    </div>
                                )
                            }
                            {/* header mode end */}
                        </div>
                    }

                    {/* background mode start */}
                    <div className="flex items-center justify-between mb-3">
                        <p className='text-sm font-bold mb-0'>Background</p>
                        <div className="flex gap-3 bg-[#F4F6FA] px-4 py-1.5 rounded-full">
                            <button className={`px-4 text-sm font-semibold py-1 rounded-full ${selectedBgMode == 1 ? 'bg-white text-[#273144]' : 'bg-transparent text-[#526281]'}`} onClick={() => setSelectedBgMode(1)}>Color</button>
                            <button className={`px-4 text-sm font-semibold py-1 rounded-full ${selectedBgMode == 2 ? 'bg-white text-[#273144]' : 'bg-transparent text-[#526281]'}`} onClick={() => setSelectedBgMode(2)}>Gradient</button>
                            <button className={`px-4 text-sm font-semibold py-1 rounded-full ${selectedBgMode == 3 ? 'bg-white text-[#273144]' : 'bg-transparent text-[#526281]'}`} onClick={() => setSelectedBgMode(3)}>Image</button>
                        </div>
                    </div>

                    {
                        selectedBgMode === 1 && (
                            <div className='flex'>
                                <input type="color" className='h-8 w-8 rounded-s-lg focus-within:outline-none border-none focus:outline-none focus:border-none' name="" id="" onChange={_debounce((e) => onBackgroundColorChange(e), 300)} defaultValue={pageData?.backgroundOption?.color} key={pageData?.backgroundOption?.color} />
                                <input type="text" className='text-black rounded-e-lg bg-[#E8EBF2] p-1 text-sm focus:outline-none' name="" id="" onBlur={(e) => onBackgroundColorChange(e)} defaultValue={pageData?.backgroundOption?.color || "#000000"} key={"input-bg-" + pageData?.backgroundOption?.color} />
                            </div>
                        )
                    }

                    {
                        selectedBgMode === 2 && (
                            <div className="flex flex-wrap gap-5 items-center">
                                <div>
                                    <p className='mb-1'>&nbsp;</p>
                                    <div className='flex items-center h-[40px]'>
                                        <input type="color" name="" id="bg-gradient-1" className='h-10 aspect-square rounded-s-md cursor-pointer' onChange={_debounce((e) => handleBackgroundGradientChange(e?.target?.value, document.getElementById('bg-gradient-2').value?.trim()), 300)} key={pageData?.backgroundOption?.gradient ? pageData?.backgroundOption?.gradient[0] : "bg-gradient-1"} defaultValue={pageData?.backgroundOption?.gradient ? pageData?.backgroundOption?.gradient[0] : "red"}
                                        // key={pageData?.backgroundOption?.gradient ? pageData?.backgroundOption?.gradient[0] : "key-bg-1"} 
                                        />

                                        <div className='w-32 h-full' style={{ background: `linear-gradient( ${pageData?.backgroundOption?.gradientAngle ? pageData?.backgroundOption?.gradientAngle : 'to bottom'}, ${pageData?.backgroundOption?.gradient?.length ? pageData?.backgroundOption?.gradient[0] : 'red'} , ${pageData?.backgroundOption?.gradient?.length ? pageData?.backgroundOption?.gradient[1] : 'blue'})` }}></div>

                                        <input type="color" name="" id="bg-gradient-2" className='h-10 aspect-square rounded-e-md cursor-pointer' onChange={_debounce((e) => handleBackgroundGradientChange(document.getElementById('bg-gradient-1').value?.trim(), e?.target?.value), 300)} key={pageData?.backgroundOption?.gradient ? pageData?.backgroundOption?.gradient[1] : "bg-gradient-2"} defaultValue={pageData?.backgroundOption?.gradient?.length ? pageData?.backgroundOption?.gradient[1] : "blue"}
                                        // key={pageData?.backgroundOption?.gradient?.length ? pageData?.backgroundOption?.gradient[1] : "key-bg-2"} 
                                        />
                                    </div>
                                </div>
                                <div>
                                    <p className='text-sm font-bold mb-1'>Direction</p>
                                    <div className="flex flex-wrap gap-2 items-center">
                                        <button className={`border-2 ${pageData?.backgroundOption?.gradientAngle == "to bottom" ? 'border-primary' : 'border-[#DBE0EB]'} rounded-full p-2`} onClick={() => onBackgroundGradientAngleChange('to bottom')}> <IconArrowDown /> </button>

                                        <button className={`border-2 ${pageData?.backgroundOption?.gradientAngle == "to top" ? 'border-primary' : 'border-[#DBE0EB]'} rounded-full p-2`} onClick={() => onBackgroundGradientAngleChange('to top')}> <IconArrowUp /> </button>

                                        <button className={`border-2 ${pageData?.backgroundOption?.gradientAngle == "to left" ? 'border-primary' : 'border-[#DBE0EB]'} rounded-full p-2`} onClick={() => onBackgroundGradientAngleChange('to left')}> <IconArrowLeft /> </button>

                                        <button className={`border-2 ${pageData?.backgroundOption?.gradientAngle == "to right" ? 'border-primary' : 'border-[#DBE0EB]'} rounded-full p-2`} onClick={() => onBackgroundGradientAngleChange('to right')}> <IconArrowRight /> </button>

                                        <button className={`border-2 ${pageData?.backgroundOption?.gradientAngle == "to right top" ? 'border-primary' : 'border-[#DBE0EB]'} rounded-full p-2`} onClick={() => onBackgroundGradientAngleChange('to right top')}> <IconArrowUpRight /> </button>

                                        <button className={`border-2 ${pageData?.backgroundOption?.gradientAngle == "to left top" ? 'border-primary' : 'border-[#DBE0EB]'} rounded-full p-2`} onClick={() => onBackgroundGradientAngleChange('to left top')}> <IconArrowUpLeft /> </button>

                                        <button className={`border-2 ${pageData?.backgroundOption?.gradientAngle == "to left bottom" ? 'border-primary' : 'border-[#DBE0EB]'} rounded-full p-2`} onClick={() => onBackgroundGradientAngleChange('to left bottom')}> <IconArrowDownLeft /> </button>

                                        <button className={`border-2 ${pageData?.backgroundOption?.gradientAngle == "to right bottom" ? 'border-primary' : 'border-[#DBE0EB]'} rounded-full p-2`} onClick={() => onBackgroundGradientAngleChange('to right bottom')}> <IconArrowDownRight /> </button>
                                    </div>
                                </div>
                            </div>
                        )
                    }

                    {
                        selectedBgMode === 3 && (
                            <div className="flex flex-wrap gap-3 items-center">
                                <input type="file" accept="image/*" name="" id="" className="hidden" onChange={onBackgroundImageChange} ref={backgroundImageInputRef} />
                                <div> <img src={pageData?.backgroundOption?.image ? (pageData?.backgroundOption?.image) : (process.env.PUBLIC_URL + "/images/image-upload.png")} className='h-20 aspect-square rounded-lg object-cover' alt="" />
                                    <p className="text-xs text-gray-400">*Maximum size: 5MB & preferred ratio is 9:16</p>
                                </div>
                                <button onClick={() => backgroundImageInputRef.current.click()} className='rounded-full px-3 py-1 font-semibold text-sm text-primary border-2 border-primary h-max'>Upload Image</button>
                                <ConfirmationModal buttonComponent={<button className='rounded-full px-3 py-1 font-semibold text-sm text-[var(--secondary)] border-2 border-secondary h-max'>Remove</button>} confirmationText={"Are you sure want to remove background image ?"} onConfirm={() => onBackgroundImageRemove()} />

                            </div>
                        )
                    }
                    {/* background mode end */}

                    <p className='text-sm font-bold mt-3 mb-1'>Text Color</p>
                    <div className="flex flex-wrap gap-5">
                        <div>
                            <p className='text-sm font-semibold mb-1 text-[#273144]'>Title</p>
                            <div className='flex'>
                                <input type="color" className='h-8 w-8 rounded-s-lg outline-none border-none focus:outline-none focus:border-none' name="" id="" onChange={_debounce((e) => onTextColorChange(e), 300)} defaultValue={pageData?.textOption?.titleColor} key={`input-title-header-${pageData?.textOption?.titleColor}`} />
                                <input type="text" className='text-black rounded-e-lg bg-[#E8EBF2] p-1 text-sm focus:outline-none' name="" id="" onBlur={(e) => onTextColorChange(e)} defaultValue={pageData?.textOption?.titleColor} key={pageData?.textOption?.titleColor} />
                            </div>
                        </div>
                        <div>
                            <p className='text-sm font-semibold mb-1 text-[#273144]'>Description</p>
                            <div className='flex'>
                                <input type="color" className='h-8 w-8 rounded-s-lg outline-none border-none focus:outline-none focus:border-none' name="" id="" onChange={_debounce((e) => onDescriptionColorChange(e), 300)} defaultValue={pageData?.textOption?.descriptionColor} key={`input-title-description-${pageData?.textOption?.descriptionColor}`} />
                                <input type="text" className='text-black rounded-e-lg bg-[#E8EBF2] p-1 text-sm focus:outline-none' name="" id="" onBlur={(e) => onDescriptionColorChange(e)} defaultValue={pageData?.textOption?.descriptionColor} key={pageData?.textOption?.descriptionColor} />
                            </div>
                        </div>
                    </div>

                </div>

                {/* socials */}
                <div className="border border-1 border-[#ECECF2] p-2 rounded-xl mb-3">
                    <p className='text-sm font-bold'>Socials</p>
                    <p className='text-sm font-semibold text-[#273144]'>Select your icons</p>
                    <div className="flex gap-2 flex-wrap mb-3">

                        {
                            socialLinks?.map((item) => {
                                return (
                                    <button key={item?.sortId} className={`flex items-center gap-2 px-3 py-1.5 rounded-full border-2 ${pageData?.socialLinks?.some(x => x.channelName == item?.name) ? 'border-primary' : 'border-[#DBE0EB]'}`} onClick={() => onSocialIconSelect(item)}>
                                        <img src={item?.icon} alt="" className='h-6' />
                                        <span className='text-sm capitalize'>{item?.name}</span>
                                    </button>
                                )
                            })
                        }
                    </div>


                    <p className='text-sm font-semibold text-[#273144]'>Edit your links</p>

                    {selectedSocialLinks?.length > 0 && <DndContext onDragEnd={handleDragEnd} modifiers={[restrictToVerticalAxis]} collisionDetection={closestCenter} sensors={sensors}>
                        <SortableContext items={selectedSocialLinks?.map(item => item?.sortId)} strategy={verticalListSortingStrategy}>
                            {
                                selectedSocialLinks?.map((item, index) => {
                                    return (
                                        <SocialDragItem key={item.sortId} socialData={item} nativeData={socialLinks?.find(x => x.name == item?.channelName)} handleDeleteDraggableItem={(itemId) => handleDeleteDraggableItem(itemId)} onSocialLinkTypeComplete={(e, item) => { onSocialLinkTypeComplete(e, item) }} />
                                    )
                                })
                            }
                        </SortableContext>
                    </DndContext>}

                    <p className='text-sm font-bold mt-3'>Style</p>
                    <div className='flex items-center gap-5'>
                        {/* <div>
                            <p className='text-sm font-semibold mb-1 text-[#273144]'>Icon Color</p>
                            <div className="flex gap-3 flex-wrap">
                                <input type="radio" id="radio-1" name="icon-color-radio-btn" value="radio-1" />
                                <label htmlFor="radio-1">Original</label>

                                <input type="radio" id="radio-2" name="icon-color-radio-btn" value="radio-2" />
                                <label htmlFor="radio-2">Black</label>

                                <input type="radio" id="radio-3" name="icon-color-radio-btn" value="radio-3" />
                                <label htmlFor="radio-3">White</label>
                            </div>
                        </div> */}
                        <div>
                            <p className='text-sm font-semibold mb-1 text-[#273144]'>Placement</p>
                            <div className="flex gap-3 flex-wrap">
                                <input type="radio" id="radio-1" name="icon-color-radio-btn" value="top" onChange={onSocialIconPositionChange} defaultChecked={pageData?.socialLinksOption?.placement == 'top'} />
                                <label htmlFor="radio-1">Top Of Page</label>

                                <input type="radio" id="radio-2" name="icon-color-radio-btn" value="bottom" onChange={onSocialIconPositionChange} defaultChecked={pageData?.socialLinksOption?.placement == 'bottom'} />
                                <label htmlFor="radio-2">Bottom Of Page</label>
                            </div>
                        </div>
                    </div>
                </div>

                {/* blocks */}
                <div className="border border-1 border-[#ECECF2] p-2 rounded-xl mb-3">
                    <p className='text-sm font-bold'>Blocks</p>
                    <p className='text-sm font-semibold text-[#273144]'>Shape</p>

                    <div className="grid grid-cols-3 gap-4 mb-4">
                        <div className={`h-12 rounded-full w-full bg-[#B1B3C8] cursor-pointer ${(pageData?.blocksOption?.background != 'transparent' && pageData?.blocksOption?.borderRadius == "35px") ? 'border-2 border-primary' : ''}`} onClick={() => onBlockStyleSelectionChange('35px', (pageData?.blocksOption?.background == 'transparent' ? '#B1B3C8' : pageData?.blocksOption?.background))}></div>

                        <div className={`h-12 rounded-lg w-full bg-[#B1B3C8] cursor-pointer ${(pageData?.blocksOption?.background != 'transparent' && pageData?.blocksOption?.borderRadius == "12px") ? 'border-2 border-primary' : ''}`} onClick={() => onBlockStyleSelectionChange('12px', (pageData?.blocksOption?.background == 'transparent' ? '#B1B3C8' : pageData?.blocksOption?.background))}></div>

                        <div className={`h-12 rounded-sm w-full bg-[#B1B3C8] cursor-pointer ${(pageData?.blocksOption?.background != 'transparent' && pageData?.blocksOption?.borderRadius == "2px") ? 'border-2 border-primary' : ''}`} onClick={() => onBlockStyleSelectionChange('2px', (pageData?.blocksOption?.background == 'transparent' ? '#B1B3C8' : pageData?.blocksOption?.background))}></div>

                        <div className={`h-12 rounded-full w-full border-2 ${(pageData?.blocksOption?.background == 'transparent' && pageData?.blocksOption?.borderRadius == "35px") ? 'border-primary' : 'border-[#B1B3C8]'} cursor-pointer`} onClick={() => onBlockStyleSelectionChange('35px', 'transparent')}></div>

                        <div className={`h-12 rounded-lg w-full border-2 ${(pageData?.blocksOption?.background == 'transparent' && pageData?.blocksOption?.borderRadius == "12px") ? 'border-primary' : 'border-[#B1B3C8]'} cursor-pointer`} onClick={() => onBlockStyleSelectionChange('12px', 'transparent')}></div>

                        <div className={`h-12 rounded-sm w-full border-2 ${(pageData?.blocksOption?.background == 'transparent' && pageData?.blocksOption?.borderRadius == "2px") ? 'border-primary' : 'border-[#B1B3C8]'} cursor-pointer`} onClick={() => onBlockStyleSelectionChange('2px', 'transparent')}></div>
                    </div>

                    <p className='text-sm font-semibold text-[#273144] mb-1'>Shadow</p>
                    <div className="flex gap-4 mb-4">
                        <div className={`h-16 w-40 border-2 rounded-lg ${pageData?.blocksOption?.shadowSize == "none" ? 'border-primary' : 'border-[#B1B3C8]'} cursor-pointer`} onClick={() => onBlockShadowSelect('none')}></div>
                        <div className={`h-16 w-40 border-2 rounded-lg ${pageData?.blocksOption?.shadowSize == "medium" ? 'border-primary' : 'border-[#B1B3C8]'} cursor-pointer`} onClick={() => onBlockShadowSelect('medium')} style={{ boxShadow: '3px 6px 2px 0px rgba(0,0,0,0.58)' }}></div>
                        <div className={`h-16 w-40 border-2 rounded-lg ${pageData?.blocksOption?.shadowSize == "large" ? 'border-primary' : 'border-[#B1B3C8]'} cursor-pointer`} onClick={() => onBlockShadowSelect('large')} style={{ boxShadow: '3px 6px 10px 0px rgba(0,0,0,0.58)' }}></div>
                    </div>

                    <p className='text-sm font-semibold text-[#273144] mb-1'>Border</p>
                    <div className="flex gap-4 mb-4">
                        <div className={`h-16 w-40 rounded-lg ${pageData?.blocksOption?.border == "0px" ? '!border-2 border-primary' : 'border-[#B1B3C8]'} shadow-md cursor-pointer`} title='No Border' onClick={() => onBlockBorderSelect('0px')}></div>
                        <div className={`h-16 w-40 border-2 rounded-lg ${pageData?.blocksOption?.border == "2px" ? 'border-primary' : 'border-'} shadow-md cursor-pointer`} onClick={() => onBlockBorderSelect('2px')}></div>
                        <div className={`h-16 w-40 border-[4px] rounded-lg ${pageData?.blocksOption?.border == "4px" ? 'border-primary' : 'border-[#B1B3C8]'} shadow-md cursor-pointer`} onClick={() => onBlockBorderSelect('4px')}></div>
                    </div>

                    <p className='text-sm font-bold'>Color</p>
                    <div className="flex !gap-5 flex-wrap">
                        <div>
                            <p className='text-sm font-semibold mb-1 text-[#273144]'>Block Title</p>
                            <div className='flex'>
                                <input type="color" className='h-8 w-8 rounded-s-lg outline-none border-none focus:outline-none focus:border-none' name="" id="" onChange={_debounce((e) => onBlockTitleColorChange(e), 300)} defaultValue={pageData?.blocksOption?.titleColor} key={pageData?.blocksOption?.titleColor} />
                                <input type="text" className='text-black rounded-e-lg bg-[#E8EBF2] p-1 text-sm focus:outline-none' name="" id="" onBlur={(e) => onBlockTitleColorChange(e)} defaultValue={pageData?.blocksOption?.titleColor} key={"input-title-block-" + pageData?.blocksOption?.titleColor} />
                            </div>
                        </div>
                        <div>
                            <p className='text-sm font-semibold mb-1 text-[#273144]'>Block Description</p>
                            <div className='flex'>
                                <input type="color" className='h-8 w-8 rounded-s-lg outline-none border-none focus:outline-none focus:border-none' name="" id="" onChange={_debounce((e) => onBlockDescriptionColorChange(e), 300)} key={pageData?.blocksOption?.descriptionColor} defaultValue={pageData?.blocksOption?.descriptionColor} />
                                <input type="text" className='text-black rounded-e-lg bg-[#E8EBF2] p-1 text-sm focus:outline-none' name="" id="" onBlur={(e) => onBlockDescriptionColorChange(e)} key={"input-description-block-" + pageData?.blocksOption?.descriptionColor} defaultValue={pageData?.blocksOption?.descriptionColor} />
                            </div>
                        </div>
                        {pageData?.blocksOption?.background != 'transparent' && <div>
                            <p className='text-sm font-semibold mb-1 text-[#273144]'>Block Background</p>
                            <div className='flex'>
                                <input type="color" className='h-8 w-8 rounded-s-lg outline-none border-none focus:outline-none focus:border-none' name="" id="" onChange={_debounce((e) => onBlockBgColorChange(e), 300)} defaultValue={pageData?.blocksOption?.background} key={pageData?.blocksOption?.background} />
                                <input type="text" className='text-black rounded-e-lg bg-[#E8EBF2] p-1 text-sm focus:outline-none' name="" id="" onBlur={(e) => onBlockBgColorChange(e)} defaultValue={pageData?.blocksOption?.background} key={"input-bg-block-" + pageData?.blocksOption?.background} />
                            </div>
                        </div>}
                        {pageData?.blocksOption?.border != '0px' && <div>
                            <p className='text-sm font-semibold mb-1 text-[#273144]'>Block Border</p>
                            <div className='flex'>
                                <input type="color" className='h-8 w-8 rounded-s-lg outline-none border-none focus:outline-none focus:border-none' name="" id="" onChange={_debounce((e) => onBlockBorderColorChange(e), 300)} defaultValue={pageData?.blocksOption?.borderColor} key={pageData?.blocksOption?.borderColor} />
                                <input type="text" className='text-black rounded-e-lg bg-[#E8EBF2] p-1 text-sm focus:outline-none' name="" id="" onBlur={(e) => onBlockBorderColorChange(e)} defaultValue={pageData?.blocksOption?.borderColor} key={"input-bg-block-" + pageData?.blocksOption?.borderColor} />
                            </div>
                        </div>}
                    </div>
                </div>

                {/* fonts */}
                <div className="border border-1 border-[#ECECF2] p-2 rounded-xl mb-3">
                    <p className='text-sm font-bold'>Fonts</p>

                    <div className='flex flex-wrap gap-3'>
                        {
                            fonts.map((item) => {
                                return (
                                    <button key={item?.id} className={`${pageData?.textOption?.font == item?.name && 'border-2 border-primary rounded-xl overflow-hidden'}`} onClick={() => onFontSelect(item)}>
                                        <img src={process.env.PUBLIC_URL + `/images/page-layouts/font-${item?.id}.png`} alt="" />
                                    </button>
                                )
                            })
                        }
                    </div>
                </div>

            </div>
        </>
    )
}

export default CreatePage;

export const SocialDragItem = ({ socialData, onSocialLinkTypeComplete, handleDeleteDraggableItem, nativeData }) => {

    const { attributes, listeners, setNodeRef, transform, transition, } = useSortable({ id: socialData?.sortId });

    const style = {
        transform: CSS.Translate.toString(transform),
        transition,
    };
    return (
        <div ref={setNodeRef} style={style}>
            <div className='flex items-center gap-2 mb-2'>
                <button className='cursor-grabbing' {...attributes} {...listeners}>
                    <IconGripVertical />
                </button>
                <img src={socialData?.icon} alt="" className='h-8' />
                <input type="text" name="" id=""
                    onBlur={(e) => onSocialLinkTypeComplete(e, socialData)}
                    onKeyDown={(e) => {
                        if (e.key === "Enter") {
                            e.preventDefault();
                            onSocialLinkTypeComplete(e, socialData);
                        }
                    }}
                    placeholder={nativeData?.placeholder}
                    defaultValue={socialData?.channelLink}
                    className='w-full border h-10 p-2 rounded-lg border-[#0000000D] text-sm' />
                <button onClick={() => handleDeleteDraggableItem(socialData?.sortId)}> <IconTrashFilled color='#EB568E' /></button>
            </div>
        </div>
    )
}